import React, { useContext } from "react";
import classnames from "classnames";
import Link from "next/link";
import getEmailUsUrl from "@/utils/getEmailUsUrl";
import { MonetateContext, trackMonetateEvent } from "../../../context/MonetateContext";
import ContactMethodsList from "./contact-methods-list/ContactMethodsList";
import styles from "./contact-methods.module.scss";

function ContactMethods({
  newDesign = false,
  fields = [],
  solutionId = null,
  location,
  contactDetails = {},
  subHeader = "If you still need help our Partners will try their best to help",
  viewContactDetails = false,
  showGreyBackground = false,
  showEmailOption,
}) {
  const { liveChatProminenceExperiment } = useContext(MonetateContext);

  let sortedFields = fields;
  const isChatAvailable = fields.some(field => field.name === "chat");
  if (liveChatProminenceExperiment && isChatAvailable) {
    sortedFields = [...fields].sort((a, b) => (a.name === "chat") - (b.name === "chat")).reverse();
  }

  const handleEmailClick = () => {
    trackMonetateEvent("email_contact_rate");
  };

  return (
    <div className={classnames(styles.cm, fields.length === 1 ? styles.oneItem : null)}>
      <div className={styles.cm__subheader}>
        {liveChatProminenceExperiment
          ? viewContactDetails
            ? "Choose how you’d like to contact us"
            : "Find the best way to contact us below."
          : subHeader}
      </div>
      <ContactMethodsList
        fields={sortedFields}
        newDesign={newDesign}
        solutionId={solutionId}
        location={location}
        contactDetails={contactDetails}
        isChatSupported
        showGreyBackground={showGreyBackground}
      />
      {contactDetails.email?.open && showEmailOption ? (
        liveChatProminenceExperiment ? (
          <p className={classnames(styles.cm__email, styles.cm_livechatprominent)}>
            Live chat or calling us is usually the quickest way to get help. Our{" "}
            <Link href={getEmailUsUrl(location)} data-test="email-us-link" onClick={handleEmailClick}>
              contact form
            </Link>{" "}
            is available, though it can take a little longer for us to come back to you.
          </p>
        ) : (
          <p className={styles.cm__email}>
            Please note: if you prefer to{" "}
            <Link href={getEmailUsUrl(location)} data-test="email-us-link" onClick={handleEmailClick}>
              email us
            </Link>
            , it may take up to 24 hours for a response and longer for us to resolve your query. We recommend phone or
            chat for a quicker response and resolution.
          </p>
        )
      ) : null}
    </div>
  );
}

export default ContactMethods;
